export const fallingSensitivitySelect = [
    { value: 1, svalue: "LowSensitivity", label: "LowSensitivity >=120cm" },
    { value: 2, svalue: "RegularSensitivity", label: "RegularSensitivity >=60cm" }
]

export const sensorMountingSelect = [
    { value: 0, svalue: "Wall", label: "Wall" },
    { value: 1, svalue: "Ceiling", label: "Ceiling" },
    { value: 2, svalue: "Ceiling45Deg", label: "Ceiling45Deg" },
    { value: 3, svalue: "Tilt45Deg", label: "Tilt45Deg" },
]

export const ledPolicySelect = [
    { value: 0, svalue: "ErrorsOnly", label: "ErrorsOnly" },
    { value: 1, svalue: "AllEvents", label: "AllEvents" },
    { value: 2, svalue: "Off", label: "Off" },
]

export const logLevelSelect = [
    { value: 0, svalue: "V_LOG_LEVEL_VERBOSE", label: "Verbose (non usare in produzione)" },
    { value: 1, svalue: "V_LOG_LEVEL_DEBUG", label: "Debug" },
    { value: 2, svalue: "V_LOG_LEVEL_INFO", label: "Info" },
    { value: 3, svalue: "V_LOG_LEVEL_WARN", label: "Warning" },
    { value: 4, svalue: "V_LOG_LEVEL_ERROR", label: "Error" },
]

export const algoProfileSelect = [
    { value: 0, svalue: "Tracking", label: "Tracking" },
    { value: 1, svalue: "Falling", label: "Falling" },
]

export const appLogSelect = [
    { value: 0, svalue: "Disable", label: "Disable" },
    { value: 1, svalue: "Error", label: "Error" },
    { value: 2, svalue: "Warn", label: "Warn" },
    { value: 3, svalue: "Info", label: "Info" },
    { value: 4, svalue: "Debug", label: "Debug" },
    { value: 5, svalue: "QaDebug", label: "QaDebug" },
    { value: 6, svalue: "Verbose", label: "Verbose" },
]

export const productTypeSelect = [
    { value: 0, svalue: "Falling", label: "Falling" },
    { value: 1, svalue: "BedExit", label: "BedExit" },
    { value: 2, svalue: "Bathroom", label: "Bathroom" },
]

export const rfRegulationZoneSelect = [
    { value: 0, svalue: "WW", label: "WW" },
    { value: 1, svalue: "JP", label: "JP" },
]

export const rfBandWidthSelect = [
    { value: 0, svalue: "BW500", label: "BW500" },
    { value: 1, svalue: "BW2500", label: "BW2500" },
]

export const bleServerTypeSelect = [
    { value: 0, svalue: "OFF", label: "OFF" },
    { value: 1, svalue: "VayyarApp", label: "VayyarApp" },
    { value: 2, svalue: "Custom1", label: "Custom1" },
]
